/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import { EventsApi } from "@/api/events";
import { DataProvider } from "react-admin";
import { ResourceName } from "../react-admin.util";

const dataProvider: DataProvider = {
  getList: async (_, params) => {
    const { pagination, sort, filter } = params;

    const events = await EventsApi.getAll({
      ...filter,
      page: pagination?.page,
      perPage: pagination?.perPage,
      sortBy: sort?.field,
      sortDirection: sort?.order.toLowerCase(),
    });

    return { data: events.data, total: events.meta.total };
  },
  getMany: () => {
    return new Promise((res) => res);
  },
  getOne: async (_, params) => {
    const { id } = params;

    const user = await EventsApi.getOne({ eventId: id });

    return { data: user };
  },
  create: () => {
    return new Promise((res) => res);
  },
  update: () => {
    return new Promise((res) => res);
  },
  updateMany: () => {
    return new Promise((res) => res);
  },
  delete: () => {
    return new Promise((res) => res);
  },
  deleteMany: () => {
    return new Promise((res) => res);
  },
  getManyReference: () => {
    return new Promise((res) => res);
  },
};

export const eventsResourceProvider = {
  resource: ResourceName.EVENTS,
  dataProvider,
};
